/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
const PhotoUpload = () => {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log('Selected file:', file);

  };

  return (
    <div className="relative gap-2 w-full my-4">
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="block w-full mt-4 text-sm text-gray-600
                   file:mr-4 file:py-2 file:px-4
                   file:rounded-lg file:border-0
                   file:text-sm file:font-semibold
                   file:bg-blue-50 file:text-navBg
                   hover:file:bg-blue-100
                   cursor-pointer"
      />
      <label
        htmlFor="file-upload"
        className="block mt-1 text-sm text-gray-600"
      >
        Upload Photo
      </label>
    </div>
  );
};

export default PhotoUpload;
